import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/shipment-category-import-jobs'
)({
  meta: () => [{ title: MENU.SHIPMENT_CATEGORY_IMPORT_HISTORY }]
})
